<template>
    <div class="serverfixed_content">
        <div class="serverfixed_box animated bounceInRight">
            <div class="serverfixed_handle">
                <i class="icon iconfont icon-icon_lianxikefu_hei"></i>
                <span>联系客服</span>
            </div>
            <div class="serverfixed_main">
                <div class="serverfixed_list">
                    <span>微信客服</span>
                    <img class="serverfixed_qrcode" :src="wxkefuimg" />
                </div>
                <div class="serverfixed_list">
                    <span>QQ客服</span>
                    <ul class="serverfixed_qq">
                        <li v-for="(item, index) in serverinfo" :key="index" v-if="item.type == 1"><a :href="'tencent://message/?uin=' + item.number + '&Site=&Menu-=yes'"><span>在线交谈</span></a></li>
                    </ul>
                </div>
                <div class="serverfixed_list">
                    <span>服务热线</span>
                    <ul class="serverfixed_tel">
                        <li v-for="(item, index) in serverinfo" :key="index" v-if="item.type == 3">{{item.number}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
export default {
    data() {
        return {
            wxkefuimg: '', // 微信二维码
            serverinfo: [], // 客服信息
        }
    },
    methods: {
        getInfo () { // 获取数据
            axios({
                url: this.getWebsite() + api.loginkf + this.getCookie('cook_ShopId'),
                method: 'post'
            })
            .then(response => {
            if (response.status === 200) {
                // console.log(response.data.msg)
                this.serverinfo = response.data.msg.datalist
                this.wxkefuimg = response.data.msg.wxkefuimg
            }
            })
            .catch(error => {
                console.log(error)
            })
        },
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

.serverfixed_content {
    transform: translateY(-50%);
    position: fixed;
    right: -60px;
    top: 50%;
    z-index: 100;
    transition: all .5s;
}

.serverfixed_box {
    position: relative;
}

.serverfixed_handle {
    width: 40px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 8px 0 0 8px;
    background-color: rgba(255, 255, 255, .6);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    opacity: 1;
    transition: all .5s;
}

.serverfixed_handle i {
    font-size: 20px;
    color: #666;
}

.serverfixed_handle span {
    width: 20px;
    margin-top: 4px;
    font-size: 14px;
    color: #666;
    display: block;
}

.serverfixed_main {
    width: 100px;
    padding: 6px 0 12px;
    text-align: center;
    background-color: #fff;
    border-radius: 8px 0 0 8px;
    position: relative;
    z-index: 2;
    opacity: 0;
    transition: all .5s;
}

.serverfixed_list {
    padding-top: 8px;
}

.serverfixed_list > span {
    font-size: 12px;
    color: #143CA9;
    display: block;
}

.serverfixed_qrcode {
    width: 60px;
    height: 60px;
    margin-top: 3px;
}

.serverfixed_qq > li {
    padding: 0 8px;
    margin-top: 6px;
}

.serverfixed_qq > li > a {
    padding-left: 22px;
    font-size: 0;
    background-image: url(../../assets/images/icon_qq.png);
    background-position: left center;
    background-repeat: no-repeat;
    display: block;
}

.serverfixed_qq > li > a > span {
    padding: 0 5px;
    font-size: 12px;
    color: #FF8000;
    border: 1px solid #FFDEBC;
    border-radius: 2px;
    display: inline-block;
}

.serverfixed_tel {
    margin-top: 2px;
}

.serverfixed_tel > li {
    height: 12px;
    line-height: 12px;
    margin-top: 6px;
    font-size: 12px;
    color: #333;
}

.serverfixed_content:hover {
    right: 0;
}

.serverfixed_content:hover .serverfixed_handle {
    opacity: 0;
}

.serverfixed_content:hover .serverfixed_main {
    opacity: 1;
}

</style>


// WEBPACK FOOTER //
// src/components/component/serverfixed.vue